export default "__VITE_ASSET__Cvtc6a9k__"